import React from 'react'
import { render } from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from './reducers'
import SupplierList from './containers/SupplierList'

const middleware = [ thunk ]
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger())
}

const store = createStore(
  reducer,
  applyMiddleware(...middleware)
)


render(
  <Provider store={store}>
    <SupplierList />
  </Provider>,
  document.getElementById('supplier_list')
)



// WEBPACK FOOTER //
// ./src/index.js